import useUpdateColorsData from '../../../../hooks/useUpdateColorsData';
import type { WidgetConfigsGenericWrapper } from '../../../common/chart-generic-wrapper';
import ConfigurationTabContent from '../../../WidgetSettingWindow/Tabs/configuration-setting-tab';
import type { WidgetShowConfigProps } from '../wizard-tab-fourth';

const WidgetConfigurationComponent = ({
  control,
  widgetConfiguration,
  watchLabelFormat,
  setSortOrder,
  setColorsSelection,
  watchWidgetType,
  sortOrder,
}: WidgetShowConfigProps) => {
  const widgetConfigurationData = useUpdateColorsData(widgetConfiguration);
  return widgetConfigurationData || watchWidgetType ? (
    <ConfigurationTabContent
      widgetConfiguration={widgetConfigurationData as Omit<WidgetConfigsGenericWrapper, 'layoutProps'>}
      control={control}
      watchLabelFormat={watchLabelFormat}
      setColors={setColorsSelection}
      setSortOrder={setSortOrder}
      sortOrder={sortOrder}
      watchWidgetType={watchWidgetType}
      showLineLabel={false}
      showDecimalPlaces={Boolean(watchLabelFormat)}
      showCustomSorting
    />
  ) : null;
};

export default WidgetConfigurationComponent;
